import React from "react";
import { func } from "prop-types";
import { Icon } from "../../atoms/icon";
import "./bookmark-remove-modal.m.css";

export const BookmarkRemoveModal = ({ onConfirm, onCancel }) => {
    return (
        <>
            <div styleName="modal-overlay" onClick={onCancel} />
            <div styleName="bookmark-remove-modal">
                <button styleName="close-button" onClick={onCancel}>
                    <Icon name="close" width="24" height="24" viewBox="0 0 24 24" />
                </button>
                <div styleName="modal-header">
                    <h3 styleName="modal-title">Do you want to remove this bookmark?</h3>
                </div>
                <div styleName="modal-actions">
                    <button styleName="cancel-button" onClick={onCancel}>
                        Cancel
                    </button>
                    <button styleName="confirm-button" onClick={onConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </>
    );
};

BookmarkRemoveModal.propTypes = {
    onConfirm: func.isRequired,
    onCancel: func.isRequired,
};
